module.exports = __webpack_public_path__ + "img/icon.linkedin.85046bbf.svg";